import React, { Component } from "react";
import { connect } from "react-redux";

import AreaHeader from "./AreaHeader";
import FieldNames      from "../../../aiim/datasets/FieldNames";
import OfficePlan      from "../../base/OfficePlan";
//import Panel from "../../../common/components/Panel";
import PeopleAndUnits  from "./PeopleAndUnits";
import Rdx     from "../../../redux/Rdx";
import Topic   from "../../../context/Topic";
import * as aiimUtil   from "../../../aiim/util/aiimUtil";
import * as component  from "../../../components/util/component";

import { TitleRow } from '../../styles/Work/workBar';

import HotelAreaUsageAnalytics from "./HotelAreaUsageAnalytics";
import Context from "../../../context/Context";
import * as val from "../../../util/val";
import * as sourceUtil from "../../base/sourceUtil";
import ModalController from "../../../common/components/Modal/ModalController";

class HotelAreaDetails extends Component {

    _mounted = false;

    requiredFieldsObj = null;
    analyticsComponent = null;
    uid = null;

    constructor(props) {
        super(props);
        this.uid = val.generateRandomUuid();
        this.state = component.newState({
            working: true,
            isShowUsagePanel: false,
            isAnalyticsDisabled: false,
        });
    }

    async componentDidMount() {
        this._mounted = true;
        component.own(this, [
            Topic.subscribe(Topic.PlanModified, params => {
                const actions = [OfficePlan.Action_AssignmentsUpdated];
                if (actions && actions.indexOf(params.action) !== -1) {
                    component.refresh(this);
                    this.onShowUsageClicked(null);
                }
            })
        ]);

        const layer = sourceUtil.getReservationsLayer();
        if (!layer) {
            console.warn("Reservations Layer not found");
            this.setState({isAnalyticsDisabled: true});
            return;
        }

        this.requiredFieldsObj = {
            FIELD_START_TIME : aiimUtil.findFieldName(layer.fields, FieldNames.START_TIME),
            FIELD_END_TIME   : aiimUtil.findFieldName(layer.fields, FieldNames.END_TIME),
            FIELD_ALL_DAY    : aiimUtil.findFieldName(layer.fields, FieldNames.ALL_DAY),
            FIELD_UNIT_ID    : aiimUtil.findFieldName(layer.fields, FieldNames.UNIT_ID),
            FIELD_STATE      : aiimUtil.findFieldName(layer.fields, FieldNames.STATE),
            FIELD_CHECK_IN_TIME  : aiimUtil.findFieldName(layer.fields, FieldNames.CHECK_IN_TIME),
            FIELD_CHECK_OUT_TIME : aiimUtil.findFieldName(layer.fields, FieldNames.CHECK_OUT_TIME)
        }
        const reqFlds = Object.values(this.requiredFieldsObj)
        if (reqFlds.includes(null)) {
            console.warn("Reservations Layer does not have all required fields. Charts/Analytics disabled", reqFlds);
            this.setState({isAnalyticsDisabled: true});
            return;
        }
    }


    componentWillUnmount() {
        component.componentWillUnmount(this);
        this._mounted = false;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.rdxActiveAreaId !== this.props.rdxActiveAreaId)
            false && console.debug("rdxActiveAreaId changed", this.uid, prevProps.rdxActiveAreaId, this.props.rdxActiveAreaId);
    }


    getAreaId() {
        const areaItem = this.getAreaItem();
        return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
    }

    getAreaItem() {
        return this.props.areaItem;
    }

    getAreaType() {
        return OfficePlan.SpaceAssignmentTypes.hotel;
    }

    hasActive() {
        return !!(this.props.rdxActiveAreaId);
    }

    isActive() {
        return (this.hasActive() && this.props.rdxActiveAreaId === this.getAreaId());
    }

    onShowUsageClicked = (e) => {
        const i18n = Context.instance.i18n;
        if (this.state.isAnalyticsDisabled && e) {
            ModalController.showMessage(i18n.spaceplanner.usageAnalytics.disabledMsg);
            return;
        }
        this.props.onIsExpanded(true);
        //hide the AssetBar's TabPanel (on the right side of the app)
        //Rdx.setValue(null, Rdx.Keys.SPACEPLANNER_ACTIVE_ASSETBAR_SECTION, null);
        this.props.setAssetBarTabKey(null);
        //e && this.setState({isShowUsagePanel: true});
        e && this.setState((state, props)=>{return {isShowUsagePanel:true}});
    }

    render() {
        const { areaItem, rdxActiveAreaKey, rdxActiveAreaId } = this.props;
        const areaType = this.getAreaType();
        const isShowUsagePanel = this.state.isShowUsagePanel && !this.props.rdxActiveAssetBarTabKey;
        return (
        <>
            <div className='i-' style={{ ...(isShowUsagePanel ? {width:"calc(100vw - 11rem)", height:"calc(100vh - 180px)"}:{}), display:"flex",}}>
                <div style={{minWidth: "19.595rem"}}>
                    <TitleRow>
                        <AreaHeader areaItem={areaItem} areaType={areaType} rdxActiveAreaKey={rdxActiveAreaKey} rdxActiveAreaId={rdxActiveAreaId} />                        
                    </TitleRow>            
                    <PeopleAndUnits areaItem={areaItem} areaType={areaType} 
                        onShowUsageClicked={this.onShowUsageClicked} 
                        isShowButton={!this.state.isShowUsagePanel && !this.state.isAnalyticsDisabled} 
                        isButtonDisabled={this.state.isAnalyticsDisabled}
                    />
                </div>
                {
                    //isShowUsagePanel &&
                    (
                        <HotelAreaUsageAnalytics 
                            onMount={ref => this.analyticsComponent = ref}
                            areaItem={this.props.areaItem}
                            activeAreaId={this.props.rdxActiveAreaId}
                            isDisabled={this.state.isAnalyticsDisabled}
                            isShowUsagePanel={isShowUsagePanel}
                            requiredFieldsObj={this.requiredFieldsObj}
                            onCloseClick={() => {
                              this.setState({isShowUsagePanel: false});
                              this.props.onIsExpanded && this.props.onIsExpanded(false);
                            }
                          }>
                        </HotelAreaUsageAnalytics>
                    )
                }
            </div>
        </>
        );
    }
}

const mapStateToProps = (rdxState, ownProps) => {
    const rdxStateToProps = {
        rdxActiveAreaId: Rdx.getValue(rdxState, Rdx.Keys.ACTIVE_HOTEL_AREA_ID),
        rdxActiveAppSection: Rdx.getValue(rdxState, Rdx.Keys.SPACEPLANNER_ACTIVE_SECTION),
        rdxActiveAssetBarTabKey: Rdx.getValue(rdxState, Rdx.Keys.SPACEPLANNER_ACTIVE_ASSETBAR_SECTION)
    };
    return rdxStateToProps;
}
const mapDispatchToProps = (dispatch) => ({
    setAssetBarTabKey: (tabKey) => dispatch(Rdx.Actions.setValue(Rdx.Keys.SPACEPLANNER_ACTIVE_ASSETBAR_SECTION, tabKey))
})

export default connect(mapStateToProps, mapDispatchToProps)(HotelAreaDetails);